import BarChartIcon from "@mui/icons-material/BarChart";
import MultilineChartIcon from "@mui/icons-material/MultilineChart";
import PieChartIcon from "@mui/icons-material/PieChart";
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import type { SvgIconComponent } from "@mui/icons-material";
import type { ChartType } from "@/features/chat/model/chatTypes";

const CHART_TYPE_ICONS: Record<ChartType, SvgIconComponent> = {
  line: ShowChartIcon,
  bar: BarChartIcon,
  area: StackedLineChartIcon,
  pie: PieChartIcon,
  scatter: ScatterPlotIcon,
  combo: MultilineChartIcon,
};

export function getChartTypeIcon(chartType: ChartType): SvgIconComponent {
  return CHART_TYPE_ICONS[chartType];
}
